const React = require('react');
const ContextProviders = require('src/hooks/ContextProviders').default;
const { I18nProvider } = require('src/hooks/useI18nContext');
const { SpacingGlobalVariables } = require('src/app/styles/spacing');
const { initTrackInteractionListener } = require('src/functions/analytics/trackInteractionListener');
const {
  resetPageLoadTimestamp,
  incrementSessionPageCount,
  captureUtmParams,
} = require('src/functions/analytics/pageState');
const { initScrollMilestoneTracking, resetScrollMilestones } = require('src/functions/analytics/trackScrollMilestones');
const { initQualitySessionTracking, checkQualitySessionOnRouteUpdate } = require('src/functions/analytics/trackQualitySession');

exports.onClientEntry = () => {
  initTrackInteractionListener();
  initScrollMilestoneTracking();
  initQualitySessionTracking();
  captureUtmParams();
};

exports.wrapPageElement = ({ element, props }) => {
  return (
    <I18nProvider pageContext={props.pageContext}>
      <ContextProviders>{element}</ContextProviders>
    </I18nProvider>
  );
};

exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (location && location.state && prevLocation) {
    location.state.referrer = prevLocation.pathname;
  }

  resetPageLoadTimestamp();
  resetScrollMilestones();
  incrementSessionPageCount();
  captureUtmParams();
  checkQualitySessionOnRouteUpdate();

  // Push page view data to GTM dataLayer on every client-side navigation.
  // This resolves 'unset' values in GA reports for page_title, page_location,
  // page_path, and page_referrer by explicitly providing them on SPA navigations.
  if (typeof window !== 'undefined' && window.dataLayer) {
    const pageData = {
      event: 'gatsby_route_update',
      page_title: document.title,
      page_location: window.location.href,
      page_path: location ? location.pathname : window.location.pathname,
      page_referrer: prevLocation ? `${window.location.origin}${prevLocation.pathname}` : document.referrer,
    };
    console.log('[GA] dataLayer push:', pageData);
    window.dataLayer.push(pageData);
  }
};
